<template>
  <Modal
      id="BalRefundEdit"
      width="80%"
      :open="visible"
      @cancel="visible = !visible"
      @ok="submit"
      :title="$t('public.name.query')"
  >
    <Row justify="center" >
      <Col span="18">
        <Row>
          <Col span="24">
            <Form
                ref="orderForm"
                :model="form"
                layout="vertical"
                :rules="validateRules"
            >
              <Row justify="space-around">

                <Col span="10">
                  <FormItem :label="$t('order.table.id_ord')" name="idOrd">
                    <Input
                        v-model:value="form.idBalLog"
                        :placeholder="$t('order.validate.id_ord')"
                        disabled
                    />
                  </FormItem>
                </Col>

                <Col span="10">
                  <FormItem :label="$t('user.table.account')" name="account">
                    <Input v-model:value="form.userAccount" disabled/>
                  </FormItem>
                </Col>

                <Col span="10">
                  <FormItem :label="$t('order.table.amount')" name="amount">
                    <InputNumber
                        v-model:value="form.amount"
                        :placeholder="$t('order.validate.amount')"
                        :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                        :min="0" :step="0.01"
                        style="width: 100%"
                        disabled
                    />
                  </FormItem>
                </Col>

                <Col span="10">
                  <FormItem :label="$t('order.table.status')" name="status">
                    <Select
                        v-model:value="form.status"
                        :placeholder="$t('order.validate.status')"
                        :options="statusList"
                        :dropdownStyle="{ zIndex: 9999999950 }"
                        disabled
                    >
                    </Select>
                  </FormItem>
                </Col>
                <Col span="22">
                  <FormItem :label="$t('public.name.remark')" name="remark">
                    <Textarea
                        v-model:value="resDate"
                        :placeholder="$t('employee.validate.required.remark')"
                        :auto-size="{ minRows: 5, maxRows: 10 }"
                        showCount
                    />
                  </FormItem>
                </Col>
                <Col span="22">
                  <Table :columns="columns" :dataSource="paymentList"
                  
                    rowKey="paymentId"
                    >
                    <template #headerCell="{ column }">
                      <template v-if="column.dataIndex === 'action'">
                        <span>
                          {{ $t("public.table.action") }}
                        </span>
                      </template>
                    </template>

                    <template #bodyCell="{column, record}">
                      <template v-if="column.dataIndex === 'action'">
                        <div class="pc-display">
                          <a @click="update(record)">
                            {{ $t("public.name.update") }}
                          </a>
                        </div>
                      </template>
                    </template>
                  </Table>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Col>
    </Row>
  </Modal>
</template>
<script>
export default {
  name: "BalRefundEdit",
}
</script>
<script setup>
import {
  Modal,
  Row,
  Col,
  Form,
  FormItem,
  Input,
  Textarea,
  InputNumber,
  Table,
  Select, message,
} from "ant-design-vue";
import {BalanceQuery,BalanceUpdateSingle} from "@/api/balanceLog";
import {reactive, ref, toRefs, computed} from "vue";
import {useI18n} from "vue-i18n"
import {useStore} from "vuex";

const store = useStore()
const i18n = useI18n()
const emits = defineEmits(['updateList'])

let visible = ref(false)
let actionType = ref("")
let title = ref("")
let resDate = ref("")

const orderForm = ref()

const typeList = [
  {value: 1, label: i18n.t("public.chargeType.0")},
  {value: 2,label: i18n.t("public.chargeType.1")},
  {value: 3, label: i18n.t("public.chargeType.2")}
]
const statusList = [{value: 0,label: i18n.t("待支付")},{value: 1,label: i18n.t("進行中")},{value: 2,label: i18n.t("已完成")},{value: 3,label: i18n.t("取消")},{value: 4,label: i18n.t("撤銷")},{value: 5,label: i18n.t("退款")}]
const payTypeList = [{value: 1, label: 'Online Pay'}, {value: 2, label: 'Balance'}]
const validateRules = {
  remark: [
    {
      required: true,
      message: i18n.t("employee.validate.required.remark"),
      trigger: "change",
    },
  ],
}

const data = reactive({
  form: {},
})
const {form} = toRefs(data)

async function editShow(obj) {
  _resetData();
  actionType.value = "edit";
  form.value = JSON.parse(JSON.stringify(obj));
  visible.value = true;

  // 获取支付信息
  const api = new BalanceQuery()
  api.get({orderNo: obj.orderNo}).then(response => {
    if (0 === parseInt(response.data.code)) {
      resDate.value = JSON.stringify(response.data.data)
    } else {
      if(response.data.code !== undefined){message.error(i18n.t("errorMsg." + response.data.code));}
    }
  })
}

function submit() {
  visible.value = false;
}

function _resetData() {
  resDate.value = ""
  form.value = {};
}

const paymentList = computed(() => {
  if(resDate.value !== ""){
    return JSON.parse(resDate.value);
  }else{
    return [];
  }
})


const columns = [
  {
    title: i18n.t("paymentId"),
    width: 10,
    fixed: "left",
    dataIndex: "paymentId",
    key: "paymentId"
  },
  {title: 'Payment No', width: 30, dataIndex: "paymentNo", key: "paymentNo"},
  {title: 'Order No', width:30, dataIndex: "orderNo", key: "orderNo"},
  {
    title: i18n.t("status"),
    width: 30,
    dataIndex: "status",
    key: "status",
    customRender: ({text}) => {
      return statusList.find(item => item.value === text).label
    }
  },
  {key: "action", width: 10, fixed: "right", dataIndex: "action"},
]

// 更新付款信息
function update(obj) {
  const api = new BalanceUpdateSingle()
  api.get({paymentNo: obj.paymentNo}).then(response => {
    if (0 === parseInt(response.data.code)) {
      const api = new BalanceQuery()
      api.get({orderNo: obj.orderNo}).then(response => {
        if (0 === parseInt(response.data.code)) {
          resDate.value = JSON.stringify(response.data.data)
        } else {
          if(response.data.code !== undefined){message.error(i18n.t("errorMsg." + response.data.code));}
        }
      })
    } else {
      if(response.data.code !== undefined){message.error(i18n.t("errorMsg." + response.data.code));}
    }
  })

}

defineExpose({
  editShow
})
</script>
